/**
 * src/modules/carousel.js
 */
export class LinkedCarousel {
	constructor(textSelector, imgSelector, nextBtnSelector, paginationSelector, delay = 200, startDelay = 0) {
		this.textSelector = textSelector;
		this.imgSelector = imgSelector;
		this.nextBtnSelector = nextBtnSelector;
		this.paginationSelector = paginationSelector;
		this.delay = delay;
		this.startDelay = startDelay + Math.round(Math.random() * 800); // 新增：啟動延遲時間

		this.Swiper = window.Swiper;
		this.gsap = window.gsap;

		if (!this.Swiper) {
			console.error('❌ Swiper CDN 未載入，輪播無法啟動');
			return;
		}

		this.init();
	}

	init() {
		const textEl = document.querySelector(this.textSelector);
		const imgEl = document.querySelector(this.imgSelector);

		const nextButtons = Array.from(document.querySelectorAll(this.nextBtnSelector));
		const paginationEls = Array.from(document.querySelectorAll(this.paginationSelector));

		if (!textEl || !imgEl) return;

		// --- 初始化 圖片輪播 (Slave) ---
		this.imgSwiper = new this.Swiper(this.imgSelector, {
			loop: true,               // 開啟無限輪播
			effect: 'fade',
			fadeEffect: { crossFade: true },
			speed: 1000,
			allowTouchMove: false,    // 禁止手動拖曳圖片，由文字區控制
			observer: true,           // 監聽 DOM 變動 (對應 Vue)
			observeParents: true,
		});

		// --- 初始化 文字輪播 (Master) ---
		this.textSwiper = new this.Swiper(this.textSelector, {
			loop: true,               // 開啟無限輪播
			speed: 800,
			spaceBetween: 50,
			observer: true,           // 監聽 DOM 變動
			observeParents: true,

			navigation: {
				nextEl: nextButtons,
			},
			pagination: {
				el: paginationEls,
				clickable: true,
				modifierClass: 'my-custom-pagination-', // 避免預設樣式干擾
				renderBullet: function (index, className) {
					return `<li class="${className}"></li>`;
				},
			},
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: true, // 額外加強：滑鼠移入時暫停
			},
		});

		// 先暫停 Autoplay，等待 startDelay 後再啟動
		if (this.textSwiper.autoplay) {
			this.textSwiper.autoplay.stop();
		}

		this.setupIntersectionObserver(textEl);

		this.bindEvents();
	}

	// 輪撥出現才進行輪播動畫
	setupIntersectionObserver(target) {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					// 關鍵修正：進入視窗後，等待我們設定的 startDelay 再啟動 Autoplay
					// 這樣就算兩個輪播同時並排出現，也會因為 startDelay 不同而錯開節奏
					setTimeout(() => {
						if (this.textSwiper && !this.textSwiper.destroyed && entry.isIntersecting) {
							this.textSwiper.autoplay.start();
						}
					}, this.startDelay);
				} else {
					// 離開視窗立即停止，節省資源
					this.textSwiper.autoplay.stop();
				}
			});
		}, {
			threshold: 0.2 // 出現 20% 就開始準備啟動
		});

		observer.observe(target);
	}

	bindEvents() {
		if (!this.textSwiper || !this.imgSwiper) return;

		// 當文字輪播切換時...
		this.textSwiper.on('slideChange', () => {

			// ★★★ 關鍵修正：使用 realIndex (0, 1, 2...) ★★★
			// 這代表資料的真實索引，不會受到 Loop 複製 Slide 的影響
			const targetIndex = this.textSwiper.realIndex;

			// 執行延遲切換
			const triggerSlide = () => {
				if (this.imgSwiper && !this.imgSwiper.destroyed) {
					// ★★★ 關鍵修正：使用 slideToLoop ★★★
					// 這會自動處理 Loop 模式下的跳轉邏輯
					this.imgSwiper.slideToLoop(targetIndex, 1000);
				}
			};

			if (this.gsap) {
				// 使用 GSAP 延遲
				this.gsap.delayedCall(this.delay / 1000, triggerSlide);
			} else {
				// 備案
				setTimeout(triggerSlide, this.delay);
			}
		});
	}
}